import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { isSubmitting, isValid, submit } from 'redux-form';

import Button from '@material-ui/core/Button';

import Form from './CompanyReduxForm';

import { FORM_NAME } from './index';
import { setCompanyData } from '../../../redux/company';
import PageBase from '../../../app/PageBase';

const mapStateToProps = state => ({
  submitting: isSubmitting(FORM_NAME)(state),
  valid: isValid(FORM_NAME)(state),
  companyId: state.companyReducer.companyId,
  open: state.companyReducer.open,
  companyData: state.companyReducer.companyData,

});
const mapDispatchToProps = {
  submit,
  setCompanyData,
};

class CompanyDialog extends Component {

  static propTypes = {
    onClose: PropTypes.func,
  };

  static defaultProps = {
    onClose: () => console.log('create!'),
  };

  submit = () => this.props.submit(FORM_NAME);

  close = () => this.props.history.push('/company/list/');

  onSubmitSuccess = () => this.props.onSubmitSuccess();

  render() {

    const {
      open, companyId, companyData, submitting, valid, consultMode,
    } = this.props;

    const dialogActions = [
      <Button
        label={I18n.t('application.close')}
        onTouchTap={this.close}
        disabled={submitting}
      />,
      <Button
        label={I18n.t('application.save')}
        primary
        keyboardFocused
        onTouchTap={this.submit}
        disabled={submitting || !valid}
      />,
    ];


    let title = companyId ? I18n.t('titles.edit') : I18n.t('titles.create');
    title += I18n.t('titles.company');
    return (

      <div>
        <PageBase
          title={title}
          showSaveButton
          handleCloseClick={this.close}
          handleSaveClick={this.submit}
          disableSaveButton={submitting || !valid}
        >
          <Form
            id={companyId}
            onSubmitSuccess={this.close}
          />

        </PageBase>

      </div>


    );

  }

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyDialog));



// WEBPACK FOOTER //
// ./src/components/tracker/Company/CompanyForm.js